import React from "react";


export default function FixedLabel(props) {
    return (
        <div className={"fixed-label"} >
            <p> {props.text}</p>
        </div>
    );
}
